import React from 'react';
import RMErrorBoundary from './RMErrorBoundary';

function withErrorBoundary<P>(WrappedComponent: React.ComponentType<P>) {
  const ComponentWithBoundary = (props: P) => (
    <RMErrorBoundary>
      <WrappedComponent {...props} />
    </RMErrorBoundary>
  );

  return ComponentWithBoundary;
}
export default withErrorBoundary;
